<div>
    <div class="c-form-group">
        <div class="c-form-group__label"><label for="filterLabel" class="required-label">Filter Label</label></div>
        <input id="filterLabel" class="c-form-group__input" [(ngModel)]="sharedService.filterLabel" cclFormInput maxlength="20" />
        <div class="c-form-group__hint">&nbsp;</div>
    </div>
    <div class="c-form-group">
        <div class="c-form-group__label"><label for="displayOptionDropdown" class="required-label">
            Filter Options
            </label>
        </div>
        <div class="flex-100 w100">
            <div ngbDropdown class="d-inline-block w100">
                <button class="btn c-form-group__input text-left w100" id="displayOptionDropdown" ngbDropdownToggle>
                    {{
                        presetOptionsSelected != 0
                            ? "Selected Fields: " +
                            presetOptionsSelected
                            : "No Filter Selected"
                    }}
                </button>
                <div
                    ngbDropdownMenu
                    aria-labelledby="displayOptionDropdown"
                    class="w100 displayOptionDropdownContent drop-down-position"
                    (click)="$event.stopPropagation()"
                >
                    <div class="col-sm-12">
                        <h6 class="c-label--accent">Standard</h6>
                        <div class="col-sm-12 plr0">
                            <div *ngFor="let field of standardFields">
                                <div [ngClass]="(this.selectedPresetFilterOptions[field.code] && this.selectedPresetFilterOptions[field.code].length > 0 && checkToDisabled(field.code)) ? 'disable' : ''">
                                    <ccl-checkbox
                                    *ngIf="field.label !== 'Session Date Range' && field.label !== 'Session Date' && field.label !== 'Session Time' && checkIfExists(field.code)"
                                    class="text-capitalize"
                                    buttonStyle="c-checkbox"
                                    (clickEvent)="setOptions(field.code, 'standardFields')"
                                    [id]="field.code"
                                    [value]="getValue(field.code)"
                                    > <span
                                    class="text-capitalize"
                                    > <b> {{ field.label }} </b> </span
                                > </ccl-checkbox>
                                <span
                                    class="text-capitalize"
                                    *ngIf="field.label === 'Session Date' || field.label === 'Session Time'"
                                    > <b> {{ field.label }} </b> </span
                                >
                                <div style="margin-left:15px" *ngIf="field.label === 'Session Date' && checkIfExists('sessionDate')">
                                    <ccl-checkbox
                                        *ngFor="let date of dates"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('selectedDate', date.id)"
                                        [id]="date.id"
                                        [value]="this.selectedPresetFilterOptions['selectedDate'] && this.selectedPresetFilterOptions['selectedDate'].indexOf(date.id) >= 0"
                                        >{{ date.label }}</ccl-checkbox
                                    >
                                </div>
                                <div style="margin-left:15px" *ngIf="field.label === 'Session Time' && checkIfExists('sessionTime')">
                                    <ccl-checkbox
                                        *ngFor="let time of times"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('selectedTime', time.id)"
                                        [id]="time.id"
                                        [value]="this.selectedPresetFilterOptions['selectedTime'] && this.selectedPresetFilterOptions['selectedTime'].indexOf(time.id) >= 0"
                                        >{{ time.label }}</ccl-checkbox
                                    >
                                </div>
                                <div style="margin-left:15px" *ngIf="field.label === 'Track' && checkIfExists('track')">
                                    <ccl-checkbox
                                        *ngFor="let track of tracks"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('track', track.id)"
                                        [id]="track.id"
                                        [value]="this.selectedPresetFilterOptions['track'] && this.selectedPresetFilterOptions['track'].indexOf(track.id) >= 0"
                                        >{{ track.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Session Type' && checkIfExists('sessionType')">
                                    <ccl-checkbox
                                        *ngFor="let type of types"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('type', type.id)"
                                        [id]="type.id"
                                        [value]="this.selectedPresetFilterOptions['type'] && this.selectedPresetFilterOptions['type'].indexOf(type.id) >= 0"
                                        >{{ type.label }}</ccl-checkbox
                                    >
                                </div>
                                <div style="margin-left:15px" *ngIf="field.label === 'Session Level' && checkIfExists('sessionLevel')">
                                    <ccl-checkbox
                                        *ngFor="let level of levels"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('level', level.id)"
                                        [id]="level.id"
                                        [value]="this.selectedPresetFilterOptions['level'] && this.selectedPresetFilterOptions['level'].indexOf(level.id) >= 0"
                                        >{{ level.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Session Location' && checkIfExists('location')">
                                    <ccl-checkbox
                                        *ngFor="let location of locations"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('location', location.id)"
                                        [id]="location.id"
                                        [value]="this.selectedPresetFilterOptions['location'] && this.selectedPresetFilterOptions['location'].indexOf(location.id) >= 0"
                                        >{{ location.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Tag' && checkIfExists('tag')">
                                    <ccl-checkbox
                                        *ngFor="let tag of tags"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('tag', tag.id)"
                                        [id]="tag.id"
                                        [value]="this.selectedPresetFilterOptions['tag'] && this.selectedPresetFilterOptions['tag'].indexOf(tag.id) >= 0"
                                        >{{ tag.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Industries' && checkIfExists('industry')">
                                    <ccl-checkbox
                                        *ngFor="let industry of industries"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('industry', industry.id)"
                                        [id]="industry.id"
                                        [value]="this.selectedPresetFilterOptions['industry'] && this.selectedPresetFilterOptions['industry'].indexOf(industry.id) >= 0"
                                        >{{ industry.label }}</ccl-checkbox
                                    >
                                </div>
                
                                <div style="margin-left:15px" *ngIf="field.label === 'Job Functions' && checkIfExists('jobFunction')">
                                    <ccl-checkbox
                                        *ngFor="let job of jobFunctions"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('jobFunction', job.id)"
                                        [id]="job.id"
                                        [value]="this.selectedPresetFilterOptions['jobFunction'] && this.selectedPresetFilterOptions['jobFunction'].indexOf(job.id) >= 0"
                                        >{{ job.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Product Goal' && checkIfExists('productGoal')">
                                    <ccl-checkbox
                                        *ngFor="let product of productGoals"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectFilterOption('productGoal', product.id)"
                                        [id]="product.id"
                                        [value]="this.selectedPresetFilterOptions['productGoal'] && this.selectedPresetFilterOptions['productGoal'].indexOf(product.id) >= 0"
                                        >{{ product.label }}</ccl-checkbox
                                    >
                                </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="customFields.length > 0">
                            <h6 class="c-label--accent">Custom</h6>
                            <div class="col-sm-12 plr0">
                                <div *ngFor="let field of customFields">
                                    <div *ngIf="checkIfExists(field.code)"
                                    [ngClass]="(this.selectedPresetFilterOptions[field.code] && this.selectedPresetFilterOptions[field.code].length > 0 && checkToDisabled(field.code)) ? 'disable' : ''">
                                       <ccl-checkbox
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="setOptions(field.code, 'customFields')"
                                        [id]="field.code"
                                        [value]="getValue(field.code)"
                                        >  <b> {{ field.label }} </b> </ccl-checkbox>
                                        <div style="margin-left:15px" *ngIf="showCustomFieldOptions">
                                            <ccl-checkbox
                                                *ngFor="let fieldValue of options[field.code]"
                                                class="text-capitalize"
                                                buttonStyle="c-checkbox"
                                                (clickEvent)="selectFilterOption(field.code, fieldValue.id)"
                                                [id]="fieldValue.id"
                                                [value]="this.selectedPresetFilterOptions[field.code] && this.selectedPresetFilterOptions[field.code].indexOf(fieldValue.id) >= 0"
                                                >{{ fieldValue.label }}</ccl-checkbox
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-form-group__hint">&nbsp;</div>
    </div>
    <div class="c-form-group" *ngIf="selectedFilters.length > 0">
        <div class="flex-100 filterTypeContainer" [model]="selectedFilters">
            <div
                class="filterTypeContainerItem text-capitalize ngx-dnd-container"
                *ngFor="let field of selectedFilters; let i = index"
                [model]="field"
            >
                <span>{{
                    field.type == "standardFields" ? standardFieldLabels[field.field] : customFieldLabels[field.field]
                }}</span>
                &nbsp;
                <span (cclClick)="removeFilter(i, field)"><i class="fa fa-remove removeIcon" title="Remove"></i></span>
                
            </div>
        </div>
        <div class="c-form-group__hint">&nbsp;</div>
    </div>
</div>